import { DynamicConf } from '@parship/psg-interfaces';
import UiTracking from '../tracking/ui-tracking';

export default class Terms {
	private terms: HTMLElement;
	private form: HTMLFormElement;
	private uiTrackingEnabled: boolean;

	public constructor(form: HTMLFormElement, dynamicConf: DynamicConf, hasGenderSelect: boolean) {
		this.form = form;
		this.terms = form.querySelector('.terms');
		this.uiTrackingEnabled = form.dataset.biEnabled === 'true';

		if (!hasGenderSelect && dynamicConf?.registration?.legalTextTermsOfService) {
			this.terms.innerHTML = dynamicConf?.registration.legalTextTermsOfService;
		} else if (dynamicConf?.registration?.legaltext) {
			this.terms.innerHTML = dynamicConf?.registration.legaltext;
		}

		this.initUiTracking();
	}

	public enableUi(): void {
		this.terms.inert = false;
	}

	private initUiTracking(): void {
		if (!this.uiTrackingEnabled) {
			return;
		}

		this.form.querySelectorAll('.terms a').forEach((link: HTMLAnchorElement) => {
			link.addEventListener(
				'click',
				() => {
					UiTracking.trackUIEvent(
						'registration-form',
						'legal-link',
						'click',
						link.pathname
					);
				},
				{ once: true }
			);
		});
	}
}
